/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ERepairshopType = 'Repairshop' | 'Bikeshop' | 'Both' | 'OnlineShop';

export const ERepairshopType = {
    Repairshop: 'Repairshop' as ERepairshopType,
    Bikeshop: 'Bikeshop' as ERepairshopType,
    Both: 'Both' as ERepairshopType,
    OnlineShop: 'OnlineShop' as ERepairshopType
};

